<div class="wrapper">
  <div class="profile-wrapper">
    <glxy-avatar [src]="profilePicUrl" [width]="36" [name]="messageFrom" shape="circle" />
  </div>
  <div class="message">
    <div class="sender-info">
      <span class="name" [innerHTML]="messageFrom"></span>
      <span class="metadata" [innerHTML]="messageMetadata"></span>
    </div>
    @if (!!subtitleText) {
      <div class="subtitle-text" [innerHTML]="subtitleText"></div>
    }
    <div class="message-text" [innerHTML]="messageText"></div>
    <div class="attachment">
      <ng-content />
    </div>
    <div class="actions">
      <ng-content select="[glxyCommentAction]" />
    </div>
  </div>
</div>
